import React from "react";
import parse from "html-react-parser";

const NotificationModal = ({notification, onCancel}) => {

    return (
        <div className="modal">
            <div
                className="modal-header"
            >
                <button
                    type="button"
                    className="modal-close"
                    onClick={onCancel}
                    style={{
                        position: 'absolute',
                        top: '16px',
                        right: '16px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#6b7280',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease',
                        lineHeight: 1,
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f3f4f6';
                        e.target.style.color = '#374151';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#6b7280';
                    }}
                    aria-label="Close notification"
                >
                    ×
                </button>

                {notification.title && (
                    <h3
                        style={{
                            margin: '0 40px 0 0',
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                            lineHeight: '1.4'
                        }}
                    >
                        {notification.title}
                    </h3>
                )}
            </div>
            <div className="modal-content">
                <div>
                    {parse(notification.text ?? '')}
                </div>
            </div>
        </div>
    );
};

export default NotificationModal;